/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1BannerPositionList200,
  GetApiV1BannerPositionList401,
  GetApiV1BannerPositionList500,
  GetApiV1BannerPositionListQueryResponse,
} from "../../types/bannerRegistroController/GetApiV1BannerPositionList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1BannerPositionList200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1BannerPositionList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1BannerPositionList401Schema =
  z.any() as unknown as ToZod<GetApiV1BannerPositionList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1BannerPositionList500Schema =
  z.any() as unknown as ToZod<GetApiV1BannerPositionList500>;

export const getApiV1BannerPositionListQueryResponseSchema = z.lazy(
  () => getApiV1BannerPositionList200Schema,
) as unknown as ToZod<GetApiV1BannerPositionListQueryResponse>;
